import React from 'react';

const Error203 = () => {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6 py-16">
      <div className="text-center max-w-2xl">
        <h1 className="text-6xl font-extrabold text-blue-600">203</h1>
        <h2 className="mt-4 text-2xl font-semibold">Bilgi Yetersiz (Non-Authoritative Information)</h2>
        <p className="mt-3 text-gray-600">
          İstenen kaynağa ilişkin bilgiler yetkili olmayan bir kaynaktan geldi. Lütfen sayfayı yenileyin veya daha sonra tekrar deneyin.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <a href="/" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">Anasayfaya Dön</a>
          <button className="px-4 py-2 border rounded" onClick={() => window.location.reload()}>Yenile</button>
        </div>
      </div>
    </div>
  );
};

export default Error203;





















